/**
 * @fileoverview POST handler for the "/companies/:company_id/app_group_permission_sets/create_permission_set" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroupPermissionSetsCreatePermissionSetCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSetProps,
  CompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSetResult,
} from "./types";

export const postCompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSet = reactQueryMutationAdapter(
  companiesCompanyIdAppGroupPermissionSetsCreatePermissionSetCacheKeys,
  (
    props: PostCompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSetProps
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSetResult> => {
    return fetch(
      `/companies/${encodeURIComponent(props.companyId)}/app_group_permission_sets/create_permission_set`,
      "POST",
      {
        name: props.name,
        permissions: props.permissions,
      }
    );
  }
);
